/**
 * iter_492 — Lightweight copyright/trademark footer used on
 * unauthenticated pages (Login / Register / Reset Password) that
 * don't render the full Layout chrome.
 */
export default function AuthFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full px-4 py-6 mt-8 border-t border-[#1a1a1a]" data-testid="auth-footer">
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-[#888] font-mono text-xs">
          © {year} One Voice Distribution™. All rights reserved.
        </p>
        <p className="text-[#555] font-mono text-[10px] mt-1.5">
          OneVoice™, OneVoice Radio™, OneVoice Studio™, AI Studio™, Song Wars™ &amp; Music Review™
          are trademarks of One Voice Distribution.
        </p>
      </div>
    </footer>
  );
}
